import { Box, Grid, Typography } from "@material-ui/core"
import classNames from "classnames"
import { useStyles } from "./historico-atualizacoes-sistemas-styles"
import { isTouchDevice } from "utils/is-touchone-device"
import { memo, useCallback, useEffect } from "react"
import { ButtonOptions } from "./components/button-options/button-options"
import { useHistory, useLocation } from "react-router-dom"
import { EnumSistemasHistorico, SistemasHistoricoMock } from "data/mocks/sistemas-roadmap-mock"

const SistemasEnumObj: Partial<Record<EnumSistemasHistorico, string>> = {
    [EnumSistemasHistorico.PDVApp]: 'atualizacoes-pdv',
    [EnumSistemasHistorico.PDVMobile]: 'atualizacoes-mobile',
    [EnumSistemasHistorico.RetaguardaApp]: 'atualizacoes-gestaov4',
    [EnumSistemasHistorico.TerminalPreVendaWindows]: 'atualizacoes-pre-venda',
    [EnumSistemasHistorico.ImpressorLocalV4]: 'atualizacoes-impressor',
    [EnumSistemasHistorico.TouchOne]: 'atualizacoes-touchone',
    [EnumSistemasHistorico.TouchonePDV]: 'atualizacoes-touchone-pdv',
    [EnumSistemasHistorico.TouchoneRetaguarda]: 'atualizacoes-touchone-retaguarda',
    [EnumSistemasHistorico.CardapioTouchOne]: 'atualizacoes-cardapio-touchone',
    [EnumSistemasHistorico.ImpressorTouchOne]: 'atualizacoes-impressor-touchone',
    [EnumSistemasHistorico.Cartorio]: 'atualizacoes-cartorio',
    [EnumSistemasHistorico.Comandas]: 'atualizacoes-comandas',
    [EnumSistemasHistorico.PedApi]: 'atualizacoes-pedapi',
    [EnumSistemasHistorico.PedidosMobile]: 'atualizacoes-pedidosmobile',
    [EnumSistemasHistorico.S2PayMobile]: 'atualizacoes-s2paymobile',
    [EnumSistemasHistorico.Transmissor]: 'atualizacoes-transmissor',
}

export interface RoadmapBacklogSistemasProps {
    carregando: boolean
    setSistemaSelected: React.Dispatch<React.SetStateAction<string>>
    sistemaSelected: string
}

const sistemaNameToSistemaRoute = (sistema: string) => {
    const getSistemaKey = SistemasHistoricoMock.find(s => s.Key === sistema)?.Key
    if (!getSistemaKey) return ''

    return SistemasEnumObj[getSistemaKey as EnumSistemasHistorico] || ''
}

const sistemaRouteToSistemaName = (route: string) => {
    const sistemasEnumReverse = Object.fromEntries(
        Object.entries(SistemasEnumObj).map(([key, value]) => [value, key])
    )
    const sistemaEncontrado = sistemasEnumReverse[route] || ''
    return Number(sistemaEncontrado)
}

const HistoricoAtualizacoesSistemasComp = ({ carregando, setSistemaSelected, sistemaSelected }: RoadmapBacklogSistemasProps) => {

    const classes = useStyles()
    const location = useLocation()
    const history = useHistory()

    const validSistemaSelected = useCallback(() => {
        setSistemaSelected(prev => {
            if (!prev) {
                // Verifica se existe um parâmetro de query 'sistema' na URL
                const params = new URLSearchParams(location.search);
                const sistemaQuery = params.get("sistema");

                // Se existir um parâmetro na query, usa ele; caso contrário, usa o primeiro sistema do sistemasMock
                if (sistemaQuery) {
                    const getSistema = sistemaRouteToSistemaName(sistemaQuery)
                    return getSistema;
                } else if (SistemasHistoricoMock.length > 0) {
                    return SistemasHistoricoMock[0].Key;
                }
                return "";
            } else {
                // Se prev existe, verifica se há um parâmetro de query 'sistema' para comparar
                const params = new URLSearchParams(location.search);
                const sistemaQuery = params.get("sistema");

                // Se existe uma query e é diferente de prev, usa a query; caso contrário, mantém prev
                if (sistemaQuery && sistemaQuery !== prev) {
                    return sistemaQuery;
                }
                return prev;
            }
        })
    }, [location.search, setSistemaSelected])

    const selecionarSistema = (sistema: string) => {
        history.replace({ search: `?sistema=${sistemaNameToSistemaRoute(sistema)}` })
        setSistemaSelected(sistema)
    }

    useEffect(() => {
        validSistemaSelected()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const sistemas = SistemasHistoricoMock

    return (
        <Box className={classes.container}>
            <Grid container spacing={1}>
                <Grid container spacing={1} className={classNames(classes.sistemas, carregando && sistemas.length === 0 && classes.gap, isTouchDevice() && classes.hiddenScroll)}>
                    {!carregando && sistemas.length === 0 && (
                        <Grid item xs={12}>
                            <Typography variant="body1" align="center">
                                Nenhum Sistema Encontrado
                            </Typography>
                        </Grid>
                    )}
                    {(!carregando || sistemas.length > 0) &&
                        sistemas
                            .sort((a, b) => a.Value.localeCompare(b.Value))
                            .map((sistema) => (
                                <Grid
                                    key={sistema.Key}
                                    item
                                    xs="auto"
                                >
                                    <ButtonOptions
                                        isSistema
                                        option={sistema}
                                        setSelected={selecionarSistema}
                                        selected={sistema.Key === sistemaSelected}
                                    />
                                </Grid>
                            ))}
                </Grid>
            </Grid>
        </Box>
    )
}

export const HistoricoAtualizacoesSistemas = memo(HistoricoAtualizacoesSistemasComp)
HistoricoAtualizacoesSistemas.displayName = 'HistoricoAtualizacoesSistemas'